import api from "./axios";


// LIST
export const getBooks = async (
    page = 1,
    limit = 10,
    search = "",
    status = ""
) => {

    const response = await api.get(
        "/books",
        {
            params: {
                page,
                limit,
                search,
                status,
            },
        }
    );

    return response.data;
};


// SINGLE
export const getBook = async (
    id
) => {

    const response = await api.get(
        `/books/${id}`
    );

    return response.data;
};


// CREATE
export const createBook = async (
    data
) => {

    const response = await api.post(
        "/books",
        data
    );

    return response.data;
};


// UPDATE
export const updateBook = async (
    id,
    data
) => {

    const response = await api.patch(
        `/books/${id}`,
        data
    );

    return response.data;
};


// DELETE / DEACTIVATE
export const deleteBook = async (
    id
) => {

    const response = await api.delete(
        `/books/${id}`
    );

    return response.data;
};